/* tslint:disable */
/* eslint-disable */
/**
 * Atelier Roles API
 * L\'Atelier des rôles (BO admin) : référentiel des briques (standard verrouillées, personnalisées administrables), profils (ensembles de rôles appliqués à la création des acteurs) et matrice rôles/portails. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NatureProfilDto } from './NatureProfilDto';
import {
    NatureProfilDtoFromJSON,
    NatureProfilDtoFromJSONTyped,
    NatureProfilDtoToJSON,
    NatureProfilDtoToJSONTyped,
} from './NatureProfilDto';
import type { ProfilDto } from './ProfilDto';
import {
    ProfilDtoFromJSON,
    ProfilDtoFromJSONTyped,
    ProfilDtoToJSON,
    ProfilDtoToJSONTyped,
} from './ProfilDto';

/**
 * 
 * @export
 * @interface GetProfilsResponse
 */
export interface GetProfilsResponse {
    /**
     * 
     * @type {Array<ProfilDto>}
     * @memberof GetProfilsResponse
     */
    profils: Array<ProfilDto>;
    /**
     * 
     * @type {Array<NatureProfilDto>}
     * @memberof GetProfilsResponse
     */
    natures: Array<NatureProfilDto>;
}

/**
 * Check if a given object implements the GetProfilsResponse interface.
 */
export function instanceOfGetProfilsResponse(value: object): value is GetProfilsResponse {
    if (!('profils' in value) || value['profils'] === undefined) return false;
    if (!('natures' in value) || value['natures'] === undefined) return false;
    return true;
}

export function GetProfilsResponseFromJSON(json: any): GetProfilsResponse {
    return GetProfilsResponseFromJSONTyped(json, false);
}

export function GetProfilsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProfilsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'profils': ((json['profils'] as Array<any>).map(ProfilDtoFromJSON)),
        'natures': ((json['natures'] as Array<any>).map(NatureProfilDtoFromJSON)),
    };
}

export function GetProfilsResponseToJSON(json: any): GetProfilsResponse {
    return GetProfilsResponseToJSONTyped(json, false);
}

export function GetProfilsResponseToJSONTyped(value?: GetProfilsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'profils': ((value['profils'] as Array<any>).map(ProfilDtoToJSON)),
        'natures': ((value['natures'] as Array<any>).map(NatureProfilDtoToJSON)),
    };
}

